import { datadogRum } from "@datadog/browser-rum"
import { onPageNavigation } from "@/utils/location"
import globals from "@/utils/globals"

const CLOUDFLARE_CSP = "report-uri https://csp-reporting.cloudflare.com/cdn-cgi/script_monitor"

const TRACKING_ENABLED_PATHS = ["/nc/signup", "/nc/success"]

const SERVICE_NAME = "web-external-web"

const updateTrackingConsent = (url) => {
  const cookiebot = window.Cookiebot || {}
  const isConsented = cookiebot.consent.statistics

  if (!isConsented) {
    return datadogRum.setTrackingConsent("not-granted")
  }

  const targetUrl = url || window.location.href || ""

  const isPathEnabled = TRACKING_ENABLED_PATHS.some((path) => targetUrl.includes(path))

  if (isPathEnabled) {
    return datadogRum.setTrackingConsent("granted")
  }
}

export default function initDatadogRUM() {
  datadogRum.init({
    // Use the same application ID as all web apps on www.blinkist.com to retain the same session
    applicationId: "5dbdd0c6-0ada-4bff-85e9-a8277510e91c",
    clientToken: "pub492d70d4966316671b7c64885e447701",
    site: "datadoghq.com",
    service: SERVICE_NAME,
    env: globals.env,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: globals.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: ["https://www.blinkist.com"],
    trackingConsent: "not-granted",
    enableExperimentalFeatures: ["feature_flags"],
    beforeSend: (event) => {
      if (event.type === "error") {
        /**
         * Do not send Cloudflare report-only CSP errors to Datadog to prevent noise
         * The CSP policy is not set by us, and is still unknown where it comes from
         * These errors do not break user experience and are report-only
         */
        if (event.error.stack.includes(CLOUDFLARE_CSP) === true) return false
      }
      return true
    }
  })

  onPageNavigation((url) => {
    updateTrackingConsent(url)
  })

  window.addEventListener("CookiebotOnConsentReady", () => {
    const cookiebot = window.Cookiebot || {}
    const consent = cookiebot.consent || {}

    datadogRum.setGlobalContextProperty("cookieConsent", {
      preferences: consent.preferences,
      marketing: consent.marketing,
      statistics: consent.statistics
    })

    updateTrackingConsent()
  })
}

export const setDatadogRumUser = (user) => {
  if (!user) return user

  datadogRum.setUser({
    fingerprint: user.fingerprint,
    id: user.userId || user.fingerprint,
    segment: user.segment,
    guest: user.guest,
    hasMobileApp: user.has_mobile_app,
    hasTrialed: user.has_trialed,
    willRenew: user.will_renew
  })

  return user
}
